<div class="container" data-cy="insurance_claim_success_page">
  <agreements-sign-verdict text="MY_BOOKING" subTitle="AGREEMENT_SIGN_SUCCESS_TITLE"
                           description="AGREEMENT_SIGN_SUCCESS_DESCRIPTION">
  </agreements-sign-verdict>
</div>

